/**
 * @voltxampere/ui — Solid-State Relay (SSR) variant (Sprint 44-5, placeholder)
 *
 * PLACEHOLDER. Yarı-iletken röle — TRIAC + opto izolasyon kompozit.
 * Sıfır mekanik temas, sessiz, hızlı (zero-cross detection ile AC
 * yarı-dalga sınırında switching). Gerçek TRIAC + opto integration
 * Sprint 47+ engine extension #4 ile aktif.
 *
 * Reference: Crydom D2425 / Omron G3MB-202P — PCB-mount + panel.
 * Input 4-32 VDC (LED control, 3-25 mA), output 240 VAC / 25 A
 * (TRIAC). Zero-cross switching, optical isolation 4000 V_RMS.
 * Heater control, motor soft-start, AC dimmer.
 *
 * Engine zero-diff invariant honored — canonical `switch` engine
 * type via schemaType (output kontakları placeholder; TRIAC + opto
 * iç yapısı Sprint 47+'da).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { switchSymbol } from "../switch.js";
export const relaySsr = {
    id: "relay-ssr",
    nameTr: "Solid-State Röle (Omron G3MB-202P, placeholder)",
    nameEn: "Solid-State Relay (Omron G3MB-202P, placeholder)",
    shortcut: "S",
    category: "passive",
    viewBox: switchSymbol.viewBox,
    terminals: switchSymbol.terminals,
    defaultLabel: "K",
    defaultValue: "SSR",
    schemaType: "switch",
    defaultParams: { closed: false, Ron: 1e-3, Roff: 1e9 },
    renderSVG: () => switchSymbol.renderSVG(),
};
//# sourceMappingURL=relay-ssr.js.map